import { combineLatest, type Observable } from 'rxjs';
import { spreadMap } from '@ardoq/rxbeach';
import type {
  APIModelAttributes,
  APIReferenceAttributes,
  APIWorkspaceAttributes,
} from '@ardoq/api-types';
import {
  components$,
  type ComponentsState,
} from 'streams/components/components$';
import { references$ } from 'streams/references/references$';
import { persistentWorkspaces$ } from 'streams/workspaces/workspaces$';
import { models$ } from 'streams/models/models$';
import type { StreamCollection } from 'streams/utils/streamUtils';
import type { DeletionEntities } from './deletionEntityNames';

const toDeletionEntities = (
  components: ComponentsState,
  references: StreamCollection<APIReferenceAttributes>,
  workspaces: StreamCollection<APIWorkspaceAttributes>,
  models: StreamCollection<APIModelAttributes>
): { entities: DeletionEntities } => ({
  entities: {
    componentsById: components.byId,
    referencesById: references.byId,
    workspacesById: workspaces.byId,
    modelsById: models.byId,
  },
});

export const deletionEntities$: Observable<{ entities: DeletionEntities }> =
  combineLatest([
    components$,
    references$,
    persistentWorkspaces$,
    models$,
  ]).pipe(spreadMap(toDeletionEntities));
